var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecommendations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1392 18.1978L18.7457 19.9359C18.9613 20.0796 19.2368 19.8694 19.1551 19.6233L18.3172 17.1089L20.0302 15.3959C20.2022 15.2244 20.0808 14.9309 19.8379 14.9309H17.7727L16.3826 12.1507C16.2824 11.9498 15.996 11.9498 15.8958 12.1507L14.5057 14.9309H12.4404C12.1981 14.9309 12.0762 15.2244 12.2477 15.3959L13.9612 17.1089L13.1232 19.6233C13.041 19.8694 13.3171 20.0796 13.5327 19.9359L16.1392 18.1978Z",
    fill: "#408C88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88269 18.7424L8.91202 19.9599C9.13581 20.0938 9.40152 19.8673 9.3046 19.6255L8.51617 17.6534L9.68466 16.4849C9.85672 16.3134 9.73529 16.0199 9.49245 16.0199H7.97168L7.12608 14.3287C7.02589 14.1278 6.73949 14.1278 6.6393 14.3287L5.7937 16.0199H4.27293C4.03063 16.0199 3.90866 16.3134 4.08018 16.4849L5.24921 17.6534L4.46023 19.6255C4.36331 19.8678 4.62957 20.0943 4.85281 19.9599L6.88269 18.7424Z",
    fill: "#408C88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3955 18.7424L27.4248 19.9599C27.6486 20.0938 27.9143 19.8673 27.8174 19.6255L27.0289 17.6534L28.1974 16.4849C28.3695 16.3134 28.2481 16.0199 28.0052 16.0199H26.4844L25.6388 14.3287C25.5387 14.1278 25.2523 14.1278 25.1521 14.3287L24.3065 16.0199H22.7857C22.5434 16.0199 22.4214 16.3134 22.5929 16.4849L23.762 17.6534L22.973 19.6255C22.8761 19.8678 23.1423 20.0943 23.3656 19.9599L25.3955 18.7424Z",
    fill: "#408C88"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendations);
export default __webpack_public_path__ + "static/media/Recommendations.3fddabc6b43a020ef866e89af94e94b3.svg";
export { ForwardRef as ReactComponent };